import { Component, ElementRef, TemplateRef, ViewChild, OnDestroy, Injectable, OnInit, Renderer2 } from "@angular/core";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { Subscription } from 'rxjs';
import { ModalService } from "@app/modules/registration/registration-card/services/modal.service";
import { ModalData } from "@app/modules/registration/registration-card/models/modal.model";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: 'app-dynamic-modal',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    NgClass,
    ReactiveFormsModule,
  ],
  templateUrl: './dynamic-modal.component.html',
  styleUrls: ['./dynamic-modal.component.scss']
})

@Injectable({
  providedIn: 'root',
})

export class DynamicModalComponent implements  OnInit, OnDestroy {
  title: string | null = '';
  body: string | null = '';
  confirmText: string | null = 'Подтвердить';
  cancelText: string | null = 'Отмена';
  onConfirm: ((data?: any) => void) | null = null;
  contentTemplate: TemplateRef<any> | null = null;
  titleColor: string | undefined = 'text-dark';
  bodyColor: string | undefined = 'text-dark';

  authForm!: FormGroup;
  showAuthForm = false;

  @ViewChild('modal', { static: false }) modalElement?: ElementRef;
  @ViewChild('modalOverlay', { static: false }) modalOverlayElement?: ElementRef;

  private modalSubscription: Subscription | null = null;

  constructor(
    private modalService: ModalService,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.modalSubscription = this.modalService.modalData$.subscribe((modal: ModalData | null) => {
      if (modal) {
        this.title = modal.title;
        this.body = modal.body;
        this.confirmText = modal.confirmText;
        this.cancelText = modal.cancelText;
        this.onConfirm = modal.onConfirm;
        this.contentTemplate = modal.contentTemplate;
        this.titleColor = modal.titleColor;
        this.bodyColor = modal.bodyColor;
        this.showAuthForm = modal.showAuthForm || false;
        this.openModal();
      } else {
        this.closeModal();
      }
    });
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  openModal() {
    if (this.modalElement && this.modalOverlayElement) {
      this.renderer.setStyle(this.modalOverlayElement.nativeElement, 'display', 'block');
      this.renderer.setStyle(this.modalElement.nativeElement, 'display', 'block');
      setTimeout(() => {
        if (this.modalOverlayElement) {
          this.renderer.addClass(this.modalOverlayElement.nativeElement, 'show');
        }
        if (this.modalElement) {
          this.renderer.addClass(this.modalElement.nativeElement, 'show');
        }
      }, 10);
    }
  }

  closeModal() {
    if (this.modalElement && this.modalOverlayElement) {
      this.renderer.removeClass(this.modalElement.nativeElement, 'show');
      this.renderer.removeClass(this.modalOverlayElement.nativeElement, 'show');

      this.renderer.setStyle(this.modalElement.nativeElement, 'display', 'none');
      this.renderer.setStyle(this.modalOverlayElement.nativeElement, 'display', 'none');
    }
  }

  actionConfirm() {
    if (this.onConfirm) {
      this.onConfirm();

      if (!this.contentTemplate) {
        this.modalService.closeModal();
      }
    }
  }

  actionCancel() {
    this.modalService.closeModal();
  }
}
